import script from "./ChangeHoldSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeHoldSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeHoldSwitch.vue?vue&type=style&index=0&id=1ec1c86e&lang=css"
import "./ChangeHoldSwitch.vue?vue&type=style&index=1&id=1ec1c86e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec1c86e"]])

export default __exports__